import { jsx } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';

const NotFound = props => {
  const {
    item
  } = props;
  const classNames = getClassNames('llm__not-found', {
    [`llm__not-found--${item.type}`]: !!item.type
  });
  return jsx("pre", {
    className: classNames,
    children: JSON.stringify(item, null, 2)
  });
};

export { NotFound };
//# sourceMappingURL=not-found.js.map
